import { Options, Vue } from 'vue-class-component';
import { AuthorizedUser } from '@/trust-admin-app/models/authorized-user';
import store from '@/trust-admin-app/store';
import { Inject } from 'vue-property-decorator';
import { TrustAPI } from '@/shared/modules/trust-api';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { orderBy } from 'lodash';
import { TrustTeamMemberView } from '@/shared/modules/typescript-trustapi-client/models';
import AccessValidationMixin from '@/shared/mixins/access-validation';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import TimesheetCalculationsMixin from '@/shared/mixins/timesheet-calculations';
import { EventEmitter } from 'events';
import { RouteN } from '@/trust-admin-app/constants/router-name';
import { RoleType } from '@/trust-admin-app/models/user';
@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator
  },
  mixins: [
    AccessValidationMixin,
    FormatDateTimeMixin,
    TimesheetCalculationsMixin
  ]
})
export default class TrustDataTrustTeam extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private searchKeyword = '';
  private sortMethod = 'desc';
  private activeSortHeader = 1;

  private tableHeadings = [
    { text: 'Name', value: 'name', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Email', value: 'email', sortMehod: 'asc', sortable: false, activeSort: false },
    { text: 'Role', value: 'role', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Supervisor', value: 'supervisor', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Charge amount', value: 'chargeAmount', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: '# Routine investigations', value: 'routeInvestations', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: '# Cause driven investigations', value: 'causeDrivenInvestigations', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Overdue timesheet', value: 'overdueTimesheet', sortMethod: 'asc', sortable: false, activeSort: false },
    { text: 'Actions', value: 'action', sortMethod: 'asc', sortable: false, activeSort: false }
  ];

  private teamMembers: TrustTeamMemberView[] = [];
  private investigatorOnly = false;

  private loadingContent = false;
  private errorLoadingContent = false;

  created(): void {
    this.loadTeamMembers();
  } 

  mounted(): void {
    this.eventCtrl.on('reload-trust-team', this.loadTeamMembers);
  }

  beforeUnmount(): void {
    this.eventCtrl.removeListener('reload-trust-team', this.loadTeamMembers);
  }

  private async loadTeamMembers(): Promise<boolean> {
    try {
      this.loadingContent = true;
      this.errorLoadingContent = false;

      const resp: any =
        await this.apiService.TrustTeamMemberApi?.apiV2TrustTeamMemberGetTrustTeamMembersPost();
        this.teamMembers = orderBy(resp.data.data as TrustTeamMemberView[], ['displayName'], 'asc');

        return Promise.resolve(false);
    } catch (err) {
      this.errorLoadingContent = true;
      return Promise.reject(true);
    } finally {
      this.loadingContent = false;
    }
  }

  get filteredTeamMembers(): TrustTeamMemberView[] {
    let teamMemberListTemp: TrustTeamMemberView[] = this.teamMembers;

    if (this.investigatorOnly) {
      teamMemberListTemp = this.teamMembers.filter(
        x => x.securityGroups.includes(RoleType.TrustInvestigator)
      );
    }

    if (this.searchKeyword.trim()) {
      teamMemberListTemp = teamMemberListTemp.filter(
        x => x.displayName.toLocaleLowerCase().includes(this.searchKeyword.toLocaleLowerCase())
      );
    }
    this.$formatSecToHours(100);
    return teamMemberListTemp;
  }

  private goToInvestigator(member: TrustTeamMemberView): void {
    store.dispatch('setSelectedTrustTeamMember', member)
    this.$router.push({ name: RouteN.TA.InvestigatorDashboard.n, query: {memberId: member.id}});
  }

  private addNewMember(): void {
    this.eventCtrl.emit('showAddEditMemberModal');
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get usrAcct(): AuthorizedUser {
    return store.getters.getUserAccount;
  }

  get RouteN(): typeof RouteN {
    return RouteN;
  }

  get showAddUserButton(): boolean {
    return this.$accessPermitted(this.usrAcct.user.roles, [
      RoleType.TrustAdmin,
      RoleType.TrustManager,
      RoleType.TrustSuperAdmin
    ]);
  }

  private sortTableColumn(index: number, sortable: boolean) {
    if (sortable) {
      if (this.tableHeadings[index].sortable) {
        this.activeSortHeader = index;
        this.sortMethod = this.sortMethod === 'desc' ? 'asc' : 'desc';
        if (this.teamMembers.length > 0) {
          const nameSorter = index == 0 ? (c: any) => c.name.toLowerCase() : [this.tableHeadings[index].value, (c: any) => c.name.toLowerCase()];
          const orderByResults = orderBy(
            this.teamMembers,
            nameSorter,
            [this.sortMethod as any]
          );
          this.teamMembers = orderByResults;
        }
      }
    }
  }
}

